import { usePageHeader } from "@/components/layouts/lib/page-header";
import { AuditLogIntro } from "./audit-log/components/AuditLogIntro";
import { AuditLogPagination } from "./audit-log/components/AuditLogPagination";
import { AuditLogTable } from "./audit-log/components/AuditLogTable";
import { AuditLogToolbar } from "./audit-log/components/AuditLogToolbar";
import {
  AUDIT_LOG_PAGE_GUIDE,
  AUDIT_LOG_PAGE_SIZE,
  AUDIT_LOG_PAGE_TIP,
} from "./audit-log/auditLogPage.constants";
import { useAuditLogPageData } from "./audit-log/hooks/useAuditLogPageData";
import { useAuditLogPageState } from "./audit-log/hooks/useAuditLogPageState";

export default function AuditLogPage() {
  const pageState = useAuditLogPageState();
  const pageData = useAuditLogPageData({
    ...pageState.apiFilters,
    page: pageState.page,
    pageSize: AUDIT_LOG_PAGE_SIZE,
  });

  usePageHeader({
    title: "Journal d'audit",
    helpTopic: "audit-log",
    guide: {
      steps: AUDIT_LOG_PAGE_GUIDE,
      tip: AUDIT_LOG_PAGE_TIP,
    },
  });

  return (
    <div>
      <AuditLogIntro />
      <AuditLogToolbar
        filters={pageState.filters}
        actions={pageData.actions}
        entityTypes={pageData.entityTypes}
        userOptions={pageData.userOptions}
        isFetching={pageData.isFetching}
        onFiltersChange={pageState.updateFilters}
        onResetFilters={pageState.resetFilters}
      />
      <AuditLogTable rows={pageData.rows} isLoading={pageData.isLoading} />
      <AuditLogPagination
        page={pageState.page}
        pageSize={AUDIT_LOG_PAGE_SIZE}
        total={pageData.total}
        onPageChange={pageState.setPage}
      />
    </div>
  );
}
